import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AttendanceService } from '../../services/attendance.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { ContextMenuComponent } from 'ngx-contextmenu';
import { UtilityService } from 'src/app/services/utility.service';
import { AllotmentConfirmationComponent } from 'src/app/courses/assignment-status/allotment-confirmation/allotment-confirmation.component';
import { ChangeStatusComponent } from '../change-status/change-status.component';
import { UserRoleService } from '../../services/user-role.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-attendance-day-type',
  templateUrl: './attendance-day-type.component.html',
  styleUrls: ['./attendance-day-type.component.scss']
})
export class AttendanceDayTypeComponent implements OnInit {
  user: any;
  currentUser: any;
  learn: any;
  boxesToUpdate: any = [];
  @Input('singleDay') singleDay;
  @Input('attendanceData') attendanceData;
  @Input('learn') learner;
  @Input('clearData') clearData;
  @Input('selectedLearner') selectedLearner
  @Input('singleJob') singleJob
  @Input('attendance') attendance;
  @Output() selectedLog: EventEmitter<any> = new EventEmitter<any>();
  @Input() contextMenu: ContextMenuComponent;
  @ViewChild(ContextMenuComponent, { static: true }) public basicMenu: ContextMenuComponent;
  @Output() updateLogs: EventEmitter<any> = new EventEmitter<any>();
  @Output() attendence: EventEmitter<any> = new EventEmitter<any>();
  userRole: any;
  jobData
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;

  /**
  * inputs:
  *      day
  *      type 'am' or 'pm'
  *      status 'amStatus' or 'pmStatus'
  *      index
  * 
  * Output:
  *      {
  *        type:
  *        day:
  *        index:
  *        isSelected: true/false
  *      }
  * 
  * If the cell is clicked once, the isSelected flag will be true, on next click it will be updated to false. This continous alternatively on every click.
  *      
  */

  private attedenceSubscription: Subject<any> = new Subject<any>();

  constructor(
    public _attendanceService: AttendanceService,
    public _utilityServices: UtilityService,
    public _change: ChangeDetectorRef,
    public _userRoleService: UserRoleService,
    public dialog: MatDialog,

  ) {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this._attendanceService.boxesToUpdateCall()
      .pipe(takeUntil(this.attedenceSubscription))
      .subscribe((res) => {
        if (res.isUpdateCell) this.boxesToUpdate = res.logDataToUpdate;
      })
  }


  ngOnDestroy() {
    this.attedenceSubscription.next();
    this.attedenceSubscription.complete();
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.singleDay && changes.singleDay.currentValue) this.singleDay = changes.singleDay.currentValue
    if (changes.attendanceData && changes.attendanceData.currentValue) this.attendanceData = changes.attendanceData.currentValue
    if (changes.learner && changes.learner.currentValue) this.learn = changes.learner.currentValue
    if (changes.clearData && changes.clearData.currentValue) this.clearCellData()

    if (changes.singleJob && changes.singleJob.currentValue) {

      this.jobData = changes.singleJob.currentValue
      this.getUserRole();
      // console.log("jobdata att.........", this.jobData);


    }
    // console.log("HERE IS THE JOBBB==>",this.jobData)

    if (changes && changes.attendance) this.attendance = changes.attendance.currentValue
    this._change.detectChanges();

  }
  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true
  }

  // UTILITY FUNCTIONS

  clearCellData() {
    if (this.attendanceData.amIsSelected) delete this.attendanceData.amIsSelected
    if (this.attendanceData.pmIsSelected) delete this.attendanceData.pmIsSelected
    $('#' + this.learn._id + '-' + this.attendanceData.day + '-' + this.singleDay).removeClass('selected');
  }

  checkArray(status, dayAttendance) {
    switch (status) {
      case "AM":
        if (dayAttendance.amStatus) {
          if (dayAttendance.amIsSelected) {
            $('#' + this.learn._id + '-' + this.attendanceData.day + '-' + 'AM').addClass('selected');
          }
          return dayAttendance.amStatus.replace(" ", "-")
        }
        break;

      case "PM":
        if (dayAttendance.pmStatus) {
          if (dayAttendance.pmIsSelected) {
            $('#' + this.learn._id + '-' + this.attendanceData.day + '-' + 'PM').addClass('selected');
          }
          return dayAttendance.pmStatus.replace(" ", "-")
        }
        break;

      default:
        break;
    }
  }

  selectLearner(singleDay, attendanceData, event) {
    console.log("this is single day", singleDay);
    console.log("attendance data", attendanceData);
    console.log("single event when click", event);

    switch (singleDay) {
      case "AM":
        if ($('#' + this.learn._id + '-' + attendanceData.day + '-' + 'AM').hasClass("selected")) {
          $('#' + this.learn._id + '-' + attendanceData.day + '-' + 'AM').removeClass('selected');
          console.log("ATTEDENCE DATA SELECT HERE ==>", this.attendanceData)

          if (attendanceData.amIsSelected) delete attendanceData.amIsSelected
          const selectedLog = {
            singleJobDateId: attendanceData.attendanceId,
            amStatus: attendanceData.amStatus
          }
          this.addDeleteData({ learner: this.learn, selectedLog, isNew: false, status: 'amStatus' });
        }
        else {
          $('#' + this.learn._id + '-' + attendanceData.day + '-' + 'AM').addClass('selected');
          const selectedLog = {
            singleJobDateId: attendanceData.attendanceId,
            amStatus: attendanceData.amStatus
          }
          this.addDeleteData({ learner: this.learn, selectedLog, isNew: true, status: 'amStatus' });
        }
        break;

      case "PM":
        if ($('#' + this.learn._id + '-' + attendanceData.day + '-' + 'PM').hasClass("selected")) {
          $('#' + this.learn._id + '-' + attendanceData.day + '-' + 'PM').removeClass('selected');
          if (attendanceData.pmIsSelected) delete attendanceData.pmIsSelected

          const selectedLog = {
            singleJobDateId: attendanceData.attendanceId,
            pmStatus: attendanceData.pmStatus
          }
          this.addDeleteData({ learner: this.learn, selectedLog, isNew: false, status: 'pmStatus' });
        }
        else {
          $('#' + this.learn._id + '-' + attendanceData.day + '-' + 'PM').addClass('selected');

          const selectedLog = {
            singleJobDateId: attendanceData.attendanceId,
            pmStatus: attendanceData.pmStatus
          }

          this.addDeleteData({ learner: this.learn, selectedLog, isNew: true, status: 'pmStatus' });
        }
        break;
      default:
        break;
    }
  }

  addDeleteData(params) {
    console.log("PArams ====>11", params);
    const objectToEdit = {
      learnerId: params.learner._id,
      attendance: params.selectedLog,
      isSelected: params.isNew,
      status: params.status
    }
    this.selectedLog.emit({ log: objectToEdit });
  }


  // API CALL

  editCell(data, singleDay) {
    console.log("context menu call here data", data);
    data['singleDay'] = singleDay;
    console.log("this.attendanceData ---> ", this.attendanceData);
    // setTimeout(() => {

    // this.openDialog(ChangeStatusComponent, data)




    const dialogRef =  this._utilityServices.commonDialogBoxOpen(ChangeStatusComponent, data, '50vw', '50vh', '50%', '50%')
      .afterClosed().subscribe(res => {
        console.log("updated data get", res);
        if (res == undefined) return
        else {
          let objectToEdit = {
            learnerId: this.learner._id,
            attendance: [],
          }
          let attendanceObj = {
          }
          if (this.singleDay == 'AM') {
            attendanceObj['amStatus'] = res.status
            attendanceObj['attendanceAmHours'] = res.time
          } else if (this.singleDay == 'PM') {
            attendanceObj['pmStatus'] = res.status
            attendanceObj['attendancePmHours'] = res.time
          }

          if (this.attendanceData.singleJobDateId) {
            attendanceObj['singleJobDateId'] = this.attendanceData.singleJobDateId
          } else {
            attendanceObj['singleJobDateId'] = this.attendanceData.attendanceId
          }
          objectToEdit.attendance.push(attendanceObj)

          console.log("this is the objectToEdit", objectToEdit);
          let objToSend = {
            jobId: this.jobData._id,
            learners: []
          }
          objToSend.learners.push(objectToEdit)
          console.log("this is the object which is send to server", objToSend);
          this._attendanceService.updateAttendance(objToSend).subscribe((response: any) => {
            console.log("this is the object which res", response);
            if (response == undefined) return
            else {
              if (response.data && response.data.length) {
                let tempData = response.data.find((x) => x._id == this.learner._id)
                let finalData = tempData.attendance.filter(item => item.singleJobDateId == this.attendanceData.attendanceId)
                let attedanceObj = finalData[0]
                this.attendanceData = attedanceObj
                console.log("attendanceData................", tempData);
                this.attendence.emit({ attendance: response.data });
                this._change.detectChanges()
                // console.log("here is the single attedence Data==>", finalData)
                this._utilityServices.handleSnackBar({ msg: "Attendance marked successfully!", button: "Ok" })
              }
            }
          })
        }
      }, (error) => {
        console.log('edit time some error occure!!', error)
        this._utilityServices.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
      })
    // }, 100);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }
}